<template>
    <div class="versions">

        <div class="row">

            <div class="col-sm-12">

                <!-- Appeals Table -->
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Version Name</th>
                            <th scope="col">Active</th>
                            <th scope="col">Published</th>
                            <th scope="col">Created On</th>
                            <th scope="col">Created By</th>
                            <th scope="col">Updated On</th>
                            <th scope="col">Updated By</th>
                            <th scope="col" class="actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(plan, index) in plans" :key="plan.id">
                            <tr :id="'row' + plan.id">
                                <td>{{ plan.name }}</td>
                                <td align="center">
                                    <i class="fas fa-check" v-if="plan.is_active_plan === 1"></i>
                                </td>
                                <td align="center">
                                    <i class="fas fa-check" v-if="plan.is_published_plan === 1"></i>
                                </td>
                                <td>{{ date(plan.created_at) }}</td>
                                <td>{{ plan.creator.name }}</td>
                                <td>{{ date(checkDuplicate(plan.created_at, plan.updated_at, plan.updated_at)) }}</td>
                                <td>{{ checkDuplicate(plan.created_at, plan.updated_at, plan.updater.name) }}</td>
                                <td class="actions">
                                    <button 
                                        class="btn btn-sm btn-primary" 
                                        title="Publish" 
                                        @click="publishPlan(plan)" 
                                        v-if="plan.is_published_plan === 0"
                                    >
                                        <i class="fa fa-upload"></i> Publish
                                    </button>
                                    <button 
                                        class="btn btn-sm btn-secondary" 
                                        @click="unpublishPlan(plan)" 
                                        title="Unpublish" 
                                        v-else
                                    >
                                        <i class="fa fa-ban"></i> Unpublish
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment';

export default defineComponent({
    name: 'PublishAPlan',
    props: {
        plans: {
            type: Array,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            plans_copy: []
        };
    },
    filters: {
        date(value) {
            if(value === null) return "";
            return moment.utc(value).local().format('M/DD/YYYY h:mm a');
        }
    },
    mounted() {
        this.plans_copy = this.plans;
    },
    methods: {
        checkDuplicate(created, updated, value) {
            if(created === updated)
                return null;
            return value;
        },
        publishPlan(plan) {
            for(let i = 0; i < this.plans_copy.length; i++) {
                if(this.plans_copy[i].is_published_plan === 1) {
                    this.plans_copy[i].is_published_plan = 0;
                    window.axios.put('/api/annual_plan/' + this.plans_copy[i].id, this.plans_copy[i]);
                }
            }

            plan.is_published_plan = 1;
            window.axios.put('/api/annual_plan/' + plan.id, plan)
                .then(() => {
                    location.reload();
                });
        },
        unpublishPlan(plan) {
            plan.is_published_plan = 0;
            window.axios.put('/api/annual_plan/' + plan.id, plan)
                .then(() => {
                    location.reload();
                });
        }
    }
});
</script>
